import React from 'react';
import '../styles/VerticalSensorCard.css';

const VerticalSensorCard = ({ image, title, points }) => {
  return (
    <div className="vertical-sensor-card">
      <div className="sensor-image">
        <img src={image} alt={title} />
      </div>
      <h3>{title}</h3>
      <ul>
        {points.map((point, idx) => (
          <li key={idx}>{point}</li>
        ))}
      </ul>
    </div>
  );
};

export default VerticalSensorCard;
